import { render } from "./payment.vue?vue&type=template&id=c74ee634&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=c74ee634&lang=scss&scoped=true"
import "./payment.vue?vue&type=style&index=1&id=c74ee634&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74ee634"]])

export default __exports__